<template>
    <flex-element :element-type="elementType">
        <section class="f-flex">
            <a-text-single-line
                v-for="(element, index) in tabElements"
                :key="element.id"
                class="f-block f-z-1"
                :class="{ [STATE_CLASSES.SELECTED]: isActiveIndex(index) }"
                v-bind="element"
                :index="index"
                :pointer="index + 1"
                @element-updated="elementUpdated"
                @click.native="onTabClick(index)"
            />
        </section>

        <o-container
            v-for="(paneElement, paneIndex) in paneElements"
            v-show="isActiveIndex(paneIndex)"
            :key="paneElement.id"
            style="margin-top: -1px"
            :index="paneIndex"
            :pointer="paneIndex + 1"
            v-bind="paneElement"
            @element-updated="elementUpdated"
        >
            <template v-slot="{ elementUpdated, elementsNew }">
                <div class="f-flex f-flex-wrap">
                    <component
                        :is="element.elementType"
                        v-for="(element, index) in elementsNew"
                        :key="element.id"
                        :pointer="index + 1"
                        :index="index"
                        v-bind="element"
                        @element-updated="elementUpdated"
                        @submit-form="submitForm"
                    />
                </div>
            </template>
        </o-container>
    </flex-element>
</template>

<script>
import uniqid from 'uniqid';

import baseOrganism from '@/mixins/base-organism/base-organism-dumb';
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'tabbed-nav',
    mixins: [baseOrganism],

    data() {
        return {
            currentTabIndex: 0,
            STATE_CLASSES,
            itemId: uniqid(),
        };
    },

    computed: {
        // even-numbered indices = tab buttons
        tabElements() {
            return this.elementsNew.filter((elem, i) => i % 2 === 0);
        },

        // odd-numbered indices = tab panes
        paneElements() {
            return this.elementsNew.filter((elem, i) => i % 2 !== 0);
        },
    },

    methods: {
        onTabClick(clickedIndex) {
            this.currentTabIndex = clickedIndex;
        },

        isActiveIndex(index) {
            return index === this.currentTabIndex;
        },
    },
};
</script>
